/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

define(['./raw.marked'], function (marked) {
	return {
		marked: marked
	};
});


//////////////////
// WEBPACK FOOTER
// ./submodules/vscode/src/vs/base/common/marked/marked.js
// module id = 485
// module chunks = 0